import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { PointSummaryDTO } from 'src/app/shared/models/dtos/responses/point-summary/point-summary-dto';
import { FamilyDTO } from 'src/app/shared/models/dtos/responses/family-dto/family-dto';

@Component({
  selector: 'app-points-summary',
  templateUrl: './points-summary.component.html',
  styleUrls: ['./points-summary.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * Shows summary of user points
 */
export class PointsSummaryComponent implements OnInit {
  private _pointSummary?: PointSummaryDTO;
  @Input() businessId?: number;
  @Input() family?: FamilyDTO;
  @Input() viewOnly!: boolean;
  @Input() reloadData!: any;
  @Input() sysAdminPointBalance!: any;
  @Input() timelineDisabled!: boolean;

  nextPointsExpiring?: number;
  nextPointsExpiringDate?: string;
  language = '';

  labels = {
    totalPoints: 'total-points',
    pointsAddedMonth: 'points-added-month',
    pointsExpiringMonth: 'points-expiring-month',
    nextPointsExpiring: 'next-points-expiring',
    pointsExpired: 'points-expired-december',
    pointsExpiring: 'points-expiring-december',
    pointsRedeemedMonth: 'points-redeemed-month',
    generateReport: 'generate-report',
  };

  /**
   * Update point summary
   * @param {PointSummaryDTO | undefined} value
   */
  @Input() set pointSummary(value: PointSummaryDTO | undefined) {
    this._pointSummary = value;
    this.nextPointsExpiring = this.pointSummary?.nextPointsExpiring;
    this.nextPointsExpiringDate = this.pointSummary?.nextPointsExpiringDate;
  }

  /**
   * Read Point Summary
   */
  get pointSummary(): PointSummaryDTO | undefined {
    return this._pointSummary;
  }

  /**
   * @constructor
   */
  constructor(
    private readonly translationService: TranslationService,
    private readonly dialogService: DialogService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.language = this.translationService.getActiveLang();
    this.translationService.translateObject(this.labels);
  }

  /**
   * Returns the current year
   * @return {any} the current year
   */
  getThisYear(): any {
    return new Date().getFullYear();
  }
}
